import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TabsWidget: WidgetRegistryEntry = {
  name: "Tabs",
  configuration: () => import("./configuration").then((m) => m.TabsWidgetConfiguration),
  component: () => import("./tabs-widget.component").then((m) => m.TabsWidgetComponent)
};
